/**
 * @generated SignedSource<<f8ffebed23463b77a87b251e6a38f051>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentUsageEntity = "collection" | "content" | "content_usage_confirmation" | "curriculum" | "dashboard_block_content" | "member_onboarding" | "organization" | "product_app" | "%future added value";
export type MemberGroupKind = "custom" | "default" | "role" | "test_user" | "%future added value";
export type MemberGroupRole = "admin" | "instructor" | "manager" | "owner" | "%future added value";
export type MemberGroupVisibility = "admin_only" | "everyone" | "%future added value";
export type ProductAppKind = "chat_channel" | "collection" | "content" | "curriculum" | "dashboard" | "events" | "group_directory" | "link" | "member_directory" | "members" | "nav_folder" | "organization_events" | "organization_members" | "posts" | "product_link" | "resources" | "slack" | "%future added value";
export type ProductType = "community_event" | "course" | "membership_plan" | "pathway" | "%future added value";
export type MentionsPluginQuery$variables = {
  includeOrg: boolean;
  organizationId: string;
  productId: string;
  search?: string | null;
  searchContent: boolean;
  searchEvents: boolean;
  searchProducts: boolean;
  searchUsers: boolean;
};
export type MentionsPluginQuery$data = {
  readonly organization?: {
    readonly contentUsages?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename?: "ContentUsage";
          readonly badge?: {
            readonly " $fragmentSpreads": FragmentRefs<"BadgeFragment">;
          } | null;
          readonly content?: {
            readonly id: string;
            readonly name: string | null;
            readonly " $fragmentSpreads": FragmentRefs<"ContentThumbnail_ContentFragment">;
          };
          readonly cover?: string;
          readonly datetimeRange?: ReadonlyArray<string>;
          readonly entity?: ContentUsageEntity;
          readonly firstName?: string | null;
          readonly fullName?: string;
          readonly id: string;
          readonly kind?: MemberGroupKind;
          readonly lastName?: string | null;
          readonly memberGroupMemberships?: {
            readonly totalCount: number;
          };
          readonly module?: {
            readonly name: string | null;
          } | null;
          readonly name?: string;
          readonly occurrenceName?: string | null;
          readonly occurrenceProduct?: {
            readonly occurrenceProductName: string;
            readonly type: ProductType;
          };
          readonly product?: {
            readonly name: string;
          } | null;
          readonly productApp?: {
            readonly customAppTitle: string | null;
            readonly kind: ProductAppKind;
          } | null;
          readonly role?: MemberGroupRole | null;
          readonly type?: ProductType;
          readonly viewerPermissions?: ReadonlyArray<string>;
          readonly visibility?: MemberGroupVisibility;
          readonly " $fragmentSpreads": FragmentRefs<"ContentUsageUtils_useContentUsageLocationLabelContentUsageFragment" | "MemberGroupTagFragment" | "ProfileAvatarFragment">;
        };
      }>;
    };
    readonly mentionables?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: "ContentUsage";
          readonly content: {
            readonly id: string;
            readonly name: string | null;
            readonly " $fragmentSpreads": FragmentRefs<"ContentThumbnail_ContentFragment">;
          };
          readonly entity: ContentUsageEntity;
          readonly id: string;
          readonly module: {
            readonly name: string | null;
          } | null;
          readonly product: {
            readonly name: string;
          } | null;
          readonly productApp: {
            readonly customAppTitle: string | null;
            readonly kind: ProductAppKind;
          } | null;
          readonly viewerPermissions: ReadonlyArray<string>;
          readonly " $fragmentSpreads": FragmentRefs<"ContentUsageUtils_useContentUsageLocationLabelContentUsageFragment">;
        } | {
          readonly __typename: "MemberGroup";
          readonly id: string;
          readonly kind: MemberGroupKind;
          readonly memberGroupMemberships: {
            readonly totalCount: number;
          };
          readonly name: string;
          readonly role: MemberGroupRole | null;
          readonly visibility: MemberGroupVisibility;
          readonly " $fragmentSpreads": FragmentRefs<"MemberGroupTagFragment">;
        } | {
          readonly __typename: "Occurrence";
          readonly datetimeRange: ReadonlyArray<string>;
          readonly id: string;
          readonly occurrenceName: string | null;
          readonly occurrenceProduct: {
            readonly occurrenceProductName: string;
            readonly type: ProductType;
          };
        } | {
          readonly __typename: "Product";
          readonly badge: {
            readonly " $fragmentSpreads": FragmentRefs<"BadgeFragment">;
          } | null;
          readonly cover: string;
          readonly id: string;
          readonly name: string;
          readonly type: ProductType;
        } | {
          readonly __typename: "User";
          readonly firstName: string | null;
          readonly fullName: string;
          readonly id: string;
          readonly lastName: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"ProfileAvatarFragment">;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        };
      }>;
    } | null;
    readonly occurrences?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename?: "ContentUsage";
          readonly content?: {
            readonly id: string;
            readonly name: string | null;
            readonly " $fragmentSpreads": FragmentRefs<"ContentThumbnail_ContentFragment">;
          };
          readonly entity?: ContentUsageEntity;
          readonly id?: string;
          readonly module?: {
            readonly name: string | null;
          } | null;
          readonly product?: {
            readonly name: string;
          } | null;
          readonly productApp?: {
            readonly customAppTitle: string | null;
            readonly kind: ProductAppKind;
          } | null;
          readonly viewerPermissions?: ReadonlyArray<string>;
          readonly " $fragmentSpreads": FragmentRefs<"ContentUsageUtils_useContentUsageLocationLabelContentUsageFragment">;
        } | {
          readonly __typename?: "MemberGroup";
          readonly id?: string;
          readonly kind?: MemberGroupKind;
          readonly memberGroupMemberships?: {
            readonly totalCount: number;
          };
          readonly name?: string;
          readonly role?: MemberGroupRole | null;
          readonly visibility?: MemberGroupVisibility;
          readonly " $fragmentSpreads": FragmentRefs<"MemberGroupTagFragment">;
        } | {
          readonly __typename?: "Occurrence";
          readonly datetimeRange?: ReadonlyArray<string>;
          readonly id?: string;
          readonly occurrenceName?: string | null;
          readonly occurrenceProduct?: {
            readonly occurrenceProductName: string;
            readonly type: ProductType;
          };
        } | {
          readonly __typename?: "Product";
          readonly badge?: {
            readonly " $fragmentSpreads": FragmentRefs<"BadgeFragment">;
          } | null;
          readonly cover?: string;
          readonly id?: string;
          readonly name?: string;
          readonly type?: ProductType;
        } | {
          readonly __typename?: "User";
          readonly firstName?: string | null;
          readonly fullName?: string;
          readonly id?: string;
          readonly lastName?: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"ProfileAvatarFragment">;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        };
      }>;
    };
    readonly products?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename?: "ContentUsage";
          readonly content?: {
            readonly id: string;
            readonly name: string | null;
            readonly " $fragmentSpreads": FragmentRefs<"ContentThumbnail_ContentFragment">;
          };
          readonly entity?: ContentUsageEntity;
          readonly id?: string;
          readonly module?: {
            readonly name: string | null;
          } | null;
          readonly product?: {
            readonly name: string;
          } | null;
          readonly productApp?: {
            readonly customAppTitle: string | null;
            readonly kind: ProductAppKind;
          } | null;
          readonly viewerPermissions?: ReadonlyArray<string>;
          readonly " $fragmentSpreads": FragmentRefs<"ContentUsageUtils_useContentUsageLocationLabelContentUsageFragment">;
        } | {
          readonly __typename?: "MemberGroup";
          readonly id?: string;
          readonly kind?: MemberGroupKind;
          readonly memberGroupMemberships?: {
            readonly totalCount: number;
          };
          readonly name?: string;
          readonly role?: MemberGroupRole | null;
          readonly visibility?: MemberGroupVisibility;
          readonly " $fragmentSpreads": FragmentRefs<"MemberGroupTagFragment">;
        } | {
          readonly __typename?: "Occurrence";
          readonly datetimeRange?: ReadonlyArray<string>;
          readonly id?: string;
          readonly occurrenceName?: string | null;
          readonly occurrenceProduct?: {
            readonly occurrenceProductName: string;
            readonly type: ProductType;
          };
        } | {
          readonly __typename?: "Product";
          readonly badge?: {
            readonly " $fragmentSpreads": FragmentRefs<"BadgeFragment">;
          } | null;
          readonly cover?: string;
          readonly id?: string;
          readonly name?: string;
          readonly type?: ProductType;
        } | {
          readonly __typename?: "User";
          readonly firstName?: string | null;
          readonly fullName?: string;
          readonly id?: string;
          readonly lastName?: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"ProfileAvatarFragment">;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        };
      }>;
    };
  } | null;
  readonly product?: {
    readonly mentionables?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: "ContentUsage";
          readonly content: {
            readonly id: string;
            readonly name: string | null;
            readonly " $fragmentSpreads": FragmentRefs<"ContentThumbnail_ContentFragment">;
          };
          readonly entity: ContentUsageEntity;
          readonly id: string;
          readonly module: {
            readonly name: string | null;
          } | null;
          readonly product: {
            readonly name: string;
          } | null;
          readonly productApp: {
            readonly customAppTitle: string | null;
            readonly kind: ProductAppKind;
          } | null;
          readonly viewerPermissions: ReadonlyArray<string>;
          readonly " $fragmentSpreads": FragmentRefs<"ContentUsageUtils_useContentUsageLocationLabelContentUsageFragment">;
        } | {
          readonly __typename: "MemberGroup";
          readonly id: string;
          readonly kind: MemberGroupKind;
          readonly memberGroupMemberships: {
            readonly totalCount: number;
          };
          readonly name: string;
          readonly role: MemberGroupRole | null;
          readonly visibility: MemberGroupVisibility;
          readonly " $fragmentSpreads": FragmentRefs<"MemberGroupTagFragment">;
        } | {
          readonly __typename: "Occurrence";
          readonly datetimeRange: ReadonlyArray<string>;
          readonly id: string;
          readonly occurrenceName: string | null;
          readonly occurrenceProduct: {
            readonly occurrenceProductName: string;
            readonly type: ProductType;
          };
        } | {
          readonly __typename: "Product";
          readonly badge: {
            readonly " $fragmentSpreads": FragmentRefs<"BadgeFragment">;
          } | null;
          readonly cover: string;
          readonly id: string;
          readonly name: string;
          readonly type: ProductType;
        } | {
          readonly __typename: "User";
          readonly firstName: string | null;
          readonly fullName: string;
          readonly id: string;
          readonly lastName: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"ProfileAvatarFragment">;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        };
      }>;
    } | null;
  } | null;
};
export type MentionsPluginQuery = {
  response: MentionsPluginQuery$data;
  variables: MentionsPluginQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeOrg"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchContent"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchEvents"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchProducts"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchUsers"
},
v8 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "productId"
  }
],
v9 = {
  "kind": "Literal",
  "name": "first",
  "value": 20
},
v10 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v11 = [
  (v9/*: any*/),
  (v10/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v17 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ProfileAvatarFragment"
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v22 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "MemberGroupTagFragment"
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "MemberGroupMembershipNodeConnection",
  "kind": "LinkedField",
  "name": "memberGroupMemberships",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cover",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Badge",
  "kind": "LinkedField",
  "name": "badge",
  "plural": false,
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BadgeFragment"
    }
  ],
  "storageKey": null
},
v27 = {
  "alias": "occurrenceName",
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "datetimeRange",
  "storageKey": null
},
v29 = {
  "alias": "occurrenceProductName",
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v30 = {
  "alias": "occurrenceProduct",
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    (v24/*: any*/),
    (v29/*: any*/)
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entity",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "content",
  "plural": false,
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContentThumbnail_ContentFragment"
    },
    (v18/*: any*/),
    (v13/*: any*/)
  ],
  "storageKey": null
},
v34 = [
  (v18/*: any*/)
],
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customAppTitle",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductApp",
  "kind": "LinkedField",
  "name": "productApp",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    (v36/*: any*/)
  ],
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "module",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": null
},
v39 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ContentUsageUtils_useContentUsageLocationLabelContentUsageFragment"
},
v40 = [
  (v12/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/)
    ],
    "type": "User",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v13/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/)
    ],
    "type": "MemberGroup",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v13/*: any*/),
      (v18/*: any*/),
      (v24/*: any*/),
      (v25/*: any*/),
      (v26/*: any*/)
    ],
    "type": "Product",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v13/*: any*/),
      (v27/*: any*/),
      (v28/*: any*/),
      (v30/*: any*/)
    ],
    "type": "Occurrence",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v13/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v35/*: any*/),
      (v37/*: any*/),
      (v38/*: any*/),
      (v39/*: any*/)
    ],
    "type": "ContentUsage",
    "abstractKey": null
  }
],
v41 = [
  {
    "alias": null,
    "args": (v11/*: any*/),
    "concreteType": "undefinedConnection",
    "kind": "LinkedField",
    "name": "mentionables",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "undefinedEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": (v40/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v42 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "organizationId"
  }
],
v43 = [
  {
    "kind": "InlineFragment",
    "selections": (v40/*: any*/),
    "type": "Mentionable",
    "abstractKey": "__isMentionable"
  }
],
v44 = [
  (v9/*: any*/),
  (v10/*: any*/),
  {
    "kind": "Literal",
    "name": "types",
    "value": [
      "course",
      "pathway"
    ]
  }
],
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatar",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTest",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSystem",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v18/*: any*/)
  ],
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "Badge",
  "kind": "LinkedField",
  "name": "badge",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    (v47/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emoji",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mediaUrl",
      "storageKey": null
    },
    (v13/*: any*/)
  ],
  "storageKey": null
},
v51 = {
  "alias": "occurrenceProduct",
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    (v24/*: any*/),
    (v29/*: any*/),
    (v13/*: any*/)
  ],
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "content",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v24/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "coverVideo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnailUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showCoverPlayIcon",
      "storageKey": null
    },
    (v18/*: any*/)
  ],
  "storageKey": null
},
v53 = [
  (v18/*: any*/),
  (v13/*: any*/)
],
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": (v53/*: any*/),
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductApp",
  "kind": "LinkedField",
  "name": "productApp",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    (v36/*: any*/),
    (v13/*: any*/)
  ],
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "module",
  "plural": false,
  "selections": (v53/*: any*/),
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "concreteType": "Collection",
  "kind": "LinkedField",
  "name": "collection",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductApp",
      "kind": "LinkedField",
      "name": "app",
      "plural": false,
      "selections": [
        (v36/*: any*/),
        (v13/*: any*/)
      ],
      "storageKey": null
    },
    (v13/*: any*/)
  ],
  "storageKey": null
},
v59 = [
  {
    "alias": null,
    "args": (v11/*: any*/),
    "concreteType": "undefinedConnection",
    "kind": "LinkedField",
    "name": "mentionables",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "undefinedEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isMentionable"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v45/*: any*/),
                  (v46/*: any*/)
                ],
                "type": "User",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v13/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v47/*: any*/),
                  (v48/*: any*/),
                  (v49/*: any*/),
                  (v23/*: any*/)
                ],
                "type": "MemberGroup",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v13/*: any*/),
                  (v18/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v50/*: any*/)
                ],
                "type": "Product",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v13/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v51/*: any*/)
                ],
                "type": "Occurrence",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v13/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  (v52/*: any*/),
                  (v54/*: any*/),
                  (v55/*: any*/),
                  (v56/*: any*/),
                  (v57/*: any*/),
                  (v58/*: any*/)
                ],
                "type": "ContentUsage",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v13/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v60 = [
  (v13/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v12/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v45/*: any*/),
          (v46/*: any*/)
        ],
        "type": "User",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v47/*: any*/),
          (v48/*: any*/),
          (v49/*: any*/),
          (v23/*: any*/)
        ],
        "type": "MemberGroup",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v18/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v50/*: any*/)
        ],
        "type": "Product",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v27/*: any*/),
          (v28/*: any*/),
          (v51/*: any*/)
        ],
        "type": "Occurrence",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          (v31/*: any*/),
          (v32/*: any*/),
          (v52/*: any*/),
          (v54/*: any*/),
          (v55/*: any*/),
          (v56/*: any*/),
          (v57/*: any*/),
          (v58/*: any*/)
        ],
        "type": "ContentUsage",
        "abstractKey": null
      }
    ],
    "type": "Mentionable",
    "abstractKey": "__isMentionable"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MentionsPluginQuery",
    "selections": [
      {
        "condition": "searchUsers",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "product",
            "args": (v8/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": (v41/*: any*/),
                "type": "Product",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "includeOrg",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "organization",
            "args": (v42/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "condition": "searchUsers",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": (v41/*: any*/)
                  },
                  {
                    "condition": "searchEvents",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v11/*: any*/),
                        "concreteType": "OccurrenceNodeConnection",
                        "kind": "LinkedField",
                        "name": "occurrences",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OccurrenceNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Occurrence",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v43/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "searchProducts",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v44/*: any*/),
                        "concreteType": "ProductNodeConnection",
                        "kind": "LinkedField",
                        "name": "products",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v43/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "searchContent",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v11/*: any*/),
                        "concreteType": "ContentUsageNodeConnection",
                        "kind": "LinkedField",
                        "name": "contentUsages",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentUsageNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentUsage",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v13/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v12/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v14/*: any*/),
                                          (v15/*: any*/),
                                          (v16/*: any*/),
                                          (v17/*: any*/)
                                        ],
                                        "type": "User",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v18/*: any*/),
                                          (v19/*: any*/),
                                          (v20/*: any*/),
                                          (v21/*: any*/),
                                          (v23/*: any*/),
                                          (v22/*: any*/)
                                        ],
                                        "type": "MemberGroup",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v18/*: any*/),
                                          (v24/*: any*/),
                                          (v25/*: any*/),
                                          (v26/*: any*/)
                                        ],
                                        "type": "Product",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v27/*: any*/),
                                          (v28/*: any*/),
                                          (v30/*: any*/)
                                        ],
                                        "type": "Occurrence",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v31/*: any*/),
                                          (v32/*: any*/),
                                          (v33/*: any*/),
                                          (v35/*: any*/),
                                          (v37/*: any*/),
                                          (v38/*: any*/),
                                          (v39/*: any*/)
                                        ],
                                        "type": "ContentUsage",
                                        "abstractKey": null
                                      }
                                    ],
                                    "type": "Mentionable",
                                    "abstractKey": "__isMentionable"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "type": "Organization",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MentionsPluginQuery",
    "selections": [
      {
        "condition": "searchUsers",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "product",
            "args": (v8/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v59/*: any*/),
                "type": "Product",
                "abstractKey": null
              },
              (v13/*: any*/)
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "includeOrg",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "organization",
            "args": (v42/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v13/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "condition": "searchUsers",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": (v59/*: any*/)
                  },
                  {
                    "condition": "searchEvents",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v11/*: any*/),
                        "concreteType": "OccurrenceNodeConnection",
                        "kind": "LinkedField",
                        "name": "occurrences",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OccurrenceNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Occurrence",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v60/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "searchProducts",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v44/*: any*/),
                        "concreteType": "ProductNodeConnection",
                        "kind": "LinkedField",
                        "name": "products",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v60/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "condition": "searchContent",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v11/*: any*/),
                        "concreteType": "ContentUsageNodeConnection",
                        "kind": "LinkedField",
                        "name": "contentUsages",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentUsageNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentUsage",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v60/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "type": "Organization",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "1a6c80133e6a453302a678e61f4194a8",
    "id": null,
    "metadata": {},
    "name": "MentionsPluginQuery",
    "operationKind": "query",
    "text": "query MentionsPluginQuery(\n  $productId: ID!\n  $organizationId: ID!\n  $search: String\n  $searchProducts: Boolean!\n  $searchEvents: Boolean!\n  $searchContent: Boolean!\n  $searchUsers: Boolean!\n  $includeOrg: Boolean!\n) {\n  product: node(id: $productId) @include(if: $searchUsers) {\n    __typename\n    ... on Product {\n      mentionables(first: 20, search: $search) {\n        edges {\n          node {\n            __typename\n            __isMentionable: __typename\n            ... on User {\n              id\n              firstName\n              lastName\n              fullName\n              ...ProfileAvatarFragment\n            }\n            ... on MemberGroup {\n              id\n              name\n              kind\n              role\n              visibility\n              ...MemberGroupTagFragment\n              memberGroupMemberships {\n                totalCount\n              }\n            }\n            ... on Product {\n              id\n              name\n              type\n              cover\n              badge {\n                ...BadgeFragment\n                id\n              }\n            }\n            ... on Occurrence {\n              id\n              occurrenceName: name\n              datetimeRange\n              occurrenceProduct: product {\n                type\n                occurrenceProductName: name\n                id\n              }\n            }\n            ... on ContentUsage {\n              id\n              entity\n              viewerPermissions\n              content {\n                ...ContentThumbnail_ContentFragment\n                name\n                id\n              }\n              product {\n                name\n                id\n              }\n              productApp {\n                kind\n                customAppTitle\n                id\n              }\n              module {\n                name\n                id\n              }\n              ...ContentUsageUtils_useContentUsageLocationLabelContentUsageFragment\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n  organization: node(id: $organizationId) @include(if: $includeOrg) {\n    __typename\n    ... on Organization {\n      mentionables(first: 20, search: $search) @include(if: $searchUsers) {\n        edges {\n          node {\n            __typename\n            __isMentionable: __typename\n            ... on User {\n              id\n              firstName\n              lastName\n              fullName\n              ...ProfileAvatarFragment\n            }\n            ... on MemberGroup {\n              id\n              name\n              kind\n              role\n              visibility\n              ...MemberGroupTagFragment\n              memberGroupMemberships {\n                totalCount\n              }\n            }\n            ... on Product {\n              id\n              name\n              type\n              cover\n              badge {\n                ...BadgeFragment\n                id\n              }\n            }\n            ... on Occurrence {\n              id\n              occurrenceName: name\n              datetimeRange\n              occurrenceProduct: product {\n                type\n                occurrenceProductName: name\n                id\n              }\n            }\n            ... on ContentUsage {\n              id\n              entity\n              viewerPermissions\n              content {\n                ...ContentThumbnail_ContentFragment\n                name\n                id\n              }\n              product {\n                name\n                id\n              }\n              productApp {\n                kind\n                customAppTitle\n                id\n              }\n              module {\n                name\n                id\n              }\n              ...ContentUsageUtils_useContentUsageLocationLabelContentUsageFragment\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n      }\n      occurrences(first: 20, search: $search) @include(if: $searchEvents) {\n        edges {\n          node {\n            ... on Mentionable {\n              __isMentionable: __typename\n              __typename\n              ... on User {\n                id\n                firstName\n                lastName\n                fullName\n                ...ProfileAvatarFragment\n              }\n              ... on MemberGroup {\n                id\n                name\n                kind\n                role\n                visibility\n                ...MemberGroupTagFragment\n                memberGroupMemberships {\n                  totalCount\n                }\n              }\n              ... on Product {\n                id\n                name\n                type\n                cover\n                badge {\n                  ...BadgeFragment\n                  id\n                }\n              }\n              ... on Occurrence {\n                id\n                occurrenceName: name\n                datetimeRange\n                occurrenceProduct: product {\n                  type\n                  occurrenceProductName: name\n                  id\n                }\n              }\n              ... on ContentUsage {\n                id\n                entity\n                viewerPermissions\n                content {\n                  ...ContentThumbnail_ContentFragment\n                  name\n                  id\n                }\n                product {\n                  name\n                  id\n                }\n                productApp {\n                  kind\n                  customAppTitle\n                  id\n                }\n                module {\n                  name\n                  id\n                }\n                ...ContentUsageUtils_useContentUsageLocationLabelContentUsageFragment\n              }\n            }\n            id\n          }\n        }\n      }\n      products(first: 20, search: $search, types: [course, pathway]) @include(if: $searchProducts) {\n        edges {\n          node {\n            ... on Mentionable {\n              __isMentionable: __typename\n              __typename\n              ... on User {\n                id\n                firstName\n                lastName\n                fullName\n                ...ProfileAvatarFragment\n              }\n              ... on MemberGroup {\n                id\n                name\n                kind\n                role\n                visibility\n                ...MemberGroupTagFragment\n                memberGroupMemberships {\n                  totalCount\n                }\n              }\n              ... on Product {\n                id\n                name\n                type\n                cover\n                badge {\n                  ...BadgeFragment\n                  id\n                }\n              }\n              ... on Occurrence {\n                id\n                occurrenceName: name\n                datetimeRange\n                occurrenceProduct: product {\n                  type\n                  occurrenceProductName: name\n                  id\n                }\n              }\n              ... on ContentUsage {\n                id\n                entity\n                viewerPermissions\n                content {\n                  ...ContentThumbnail_ContentFragment\n                  name\n                  id\n                }\n                product {\n                  name\n                  id\n                }\n                productApp {\n                  kind\n                  customAppTitle\n                  id\n                }\n                module {\n                  name\n                  id\n                }\n                ...ContentUsageUtils_useContentUsageLocationLabelContentUsageFragment\n              }\n            }\n            id\n          }\n        }\n      }\n      contentUsages(first: 20, search: $search) @include(if: $searchContent) {\n        edges {\n          node {\n            id\n            ... on Mentionable {\n              __isMentionable: __typename\n              __typename\n              ... on User {\n                id\n                firstName\n                lastName\n                fullName\n                ...ProfileAvatarFragment\n              }\n              ... on MemberGroup {\n                id\n                name\n                kind\n                role\n                visibility\n                ...MemberGroupTagFragment\n                memberGroupMemberships {\n                  totalCount\n                }\n              }\n              ... on Product {\n                id\n                name\n                type\n                cover\n                badge {\n                  ...BadgeFragment\n                  id\n                }\n              }\n              ... on Occurrence {\n                id\n                occurrenceName: name\n                datetimeRange\n                occurrenceProduct: product {\n                  type\n                  occurrenceProductName: name\n                  id\n                }\n              }\n              ... on ContentUsage {\n                id\n                entity\n                viewerPermissions\n                content {\n                  ...ContentThumbnail_ContentFragment\n                  name\n                  id\n                }\n                product {\n                  name\n                  id\n                }\n                productApp {\n                  kind\n                  customAppTitle\n                  id\n                }\n                module {\n                  name\n                  id\n                }\n                ...ContentUsageUtils_useContentUsageLocationLabelContentUsageFragment\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment BadgeFragment on Badge {\n  kind\n  color\n  icon\n  emoji\n  mediaUrl\n}\n\nfragment ContentThumbnail_ContentFragment on Content {\n  id\n  type\n  coverVideo\n  thumbnailUrl\n  showCoverPlayIcon\n}\n\nfragment ContentUsageUtils_useContentUsageLocationLabelContentUsageFragment on ContentUsage {\n  id\n  entity\n  entityId\n  product {\n    name\n    id\n  }\n  productApp {\n    kind\n    customAppTitle\n    id\n  }\n  collection {\n    app {\n      customAppTitle\n      id\n    }\n    id\n  }\n  module {\n    name\n    id\n  }\n}\n\nfragment MemberGroupTagFragment on MemberGroup {\n  id\n  name\n  kind\n  color\n  role\n  isSystem\n  product {\n    id\n    name\n  }\n}\n\nfragment ProfileAvatarFragment on User {\n  id\n  fullName\n  avatar\n  isTest\n}\n"
  }
};
})();

(node as any).hash = "2ebd560604610be1ac6abbb546355750";

export default node;
